import { render, staticRenderFns } from "./ReclutamientoView.vue?vue&type=template&id=30872b50&scoped=true"
import script from "./ReclutamientoView.vue?vue&type=script&lang=js"
export * from "./ReclutamientoView.vue?vue&type=script&lang=js"
import style0 from "./ReclutamientoView.vue?vue&type=style&index=0&id=30872b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30872b50",
  null
  
)

export default component.exports